export enum SAAS_INVOICE_PAY_MODE {
  ONLINE = 'ONLINE',
  MANUAL = 'MANUAL',
}

export enum SAAS_INVOICE_STATUS {
  DUE = 'DUE',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
  PARTIAL_PAID = 'PARTIAL_PAID',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  REJECTED = 'REJECTED',
}

export enum SAAS_INVOICE_CHIP_COLORS {
  PENDING_PAYMENT = '#E6A03A',
  PAID = '#459B64',
  DUE = '#0047AB',
  REJECTED = '#E6A03B', // should change
  PARTIAL_PAID = '#E6A03C', // should change
  OVERDUE = 'red', // should change

  TEXT_COLOR = 'white',
}
